// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css, keyframes } from 'styled-components';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { THANKYOU_ICON_FILL_COLOUR } from '@tcp/core/src/constants/brandSpecific.constants';

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideUp = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-100%);
    opacity: 0;
  }
`;

export default css`
  ${(props) =>
    props.isConfirmationPageRoute &&
    `
background-color: white;`}
  margin-bottom: ${(props) => (props.isConfirmationPageRoute ? '0px' : '8px')};

  &.removeX-hidden + div #overlayWrapper {
    overflow-x: visible !important;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    margin-bottom: ${(props) => (props.isConfirmationPageRoute ? '0px' : '24px')};
  }
  .header-promo__container {
    margin-top: 20px;
    display: block;
  }
  .header-middle-nav-bar {
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) =>
        props.isNewNavigationImagesEnabled
          ? ''
          : `border-bottom: 1px solid;
            border-color: ${THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()]};`};
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      border-bottom: 1px solid;
      border-color: ${(props) =>
        props.isNewNavigationImagesEnabled
          ? props.theme.colorPalette.gray[3200]
          : THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()]};
    }
    ${(props) =>
      !props.isHeaderScrollViewDisabled && props.isStickyHeaderBgColorEnabled
        ? `
      @media ${props.theme.mediaQuery.large} {
        border-bottom: 1px solid ${props.theme.colorPalette.gray[3200]};

      }
    `
        : ``}
    ${(props) =>
      !props.isHeaderScrollViewDisabled && props.isStickyHeaderBgColorEnabled
        ? `
        border-bottom: 1px solid ${props.theme.colorPalette.gray[3200]} !important;
    `
        : ``}
  }

  .header-middle-nav {
    ${(props) =>
      !props.isHeaderScrollViewDisabled && props.isStickyHeaderBgColorEnabled
        ? `
        border-bottom: 1px solid ${props.theme.colorPalette.gray[3200]};
        width: 100%;
        margin: 0;
        @media ${props.theme.mediaQuery.large} {
          background: ${props.theme.colorPalette.blue.C900};
        }
    `
        : ``}
  }

  .brands-wrapper {
    ${(props) =>
      !props.isHeaderScrollViewDisabled && props.isStickyHeaderBgColorEnabled
        ? `
          background: ${props.theme.colorPalette.blue.C900};
          border-bottom: 0 solid #d9d9d9 !important;
          @media ${props.theme.mediaQuery.smallOnly} {
            a.brand-tab-tcp, a.brand-tab-gymboree, button.brand-tab-tcp, button.brand-tab-gymboree {
              width: 50% !important;
            }
          }
          span.brand-seperator {
            display: none;
          }
          a.brand-tab-pjp, a.brand-tab-snj, button.brand-tab-pjp, button.brand-tab-snj {
            display: none;
          }
        `
        : ``}
  }

  .bannerClosed {
    display: none;
  }

  .shop-thi-store-notification {
    margin: 6px 0px;
    p {
      flex-grow: 1;
    }
  }
`;

export const HeaderTag = styled.div`
  &.header-sticky {
    box-sizing: border-box;
    position: sticky;
    top: 0;
    width: 100%;
    z-index: ${(props) => props.theme.zindex.zCondensedHeader};
    transition: all 0.3s ease-in-out;
    animation: ${slideDown} 0.3s ease-in forwards;
  }
  &.slide-up {
    animation: ${slideUp} 0.3s ease-in forwards;
  }
  ${(props) =>
    props.isDrawerOpen
      ? `
    position: sticky;
    top: 0;
    z-index: ${props.theme.zindex.zCondensedHeader};
    background-color: #FFF;
    `
      : ``}
`;

export const SkipMain = styled(Anchor)`
  padding: 6px;
  position: absolute;
  top: -9999px;
  left: -9999px;
  color: ${(props) => props.theme.colorPalette.white};
  border-right: 1px solid ${(props) => props.theme.colorPalette.white};
  border-bottom: 1px solid ${(props) => props.theme.colorPalette.white};
  border-bottom-right-radius: 8px;
  background: ${(props) => props.theme.colors.BRAND.PRIMARY};
  -webkit-transition: top 1s ease-out;
  transition: top 1s ease-out;
  z-index: ${(props) => props.theme.zindex.zEnlargedImage};

  &.skip-main:focus,
  &.skip-main:active {
    position: absolute;
    left: 0px;
    top: 0px;
    outline-color: transparent;
    -webkit-transition: top 0.1s ease-in;
    transition: top 0.1s ease-in;
  }
`;
